import { c as _c } from "react/compiler-runtime";
import { SphereDropzone } from "@components/common/sphere-dropzone/sphere-dropzone";
import { isSingleFileUploadResponse } from "@custom-types/file-upload-type-guards";
import { UploadElementType } from "@custom-types/file-upload-types";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useBrandingSettings } from "@hooks/use-branding-settings";
import { useState } from "react";

/** Renders the workspace logo settings */
export function WorkspaceLogoSetting() {
  const $ = _c(14);
  const companyId = useCompanyId();
  const {
    brandingSettings,
    onChangeBrandingSettings
  } = useBrandingSettings();
  const [isUploadingLogo, setIsUploadingLogo] = useState(false);
  let t0;
  if ($[0] !== onChangeBrandingSettings) {
    t0 = async function onUploadWorkspaceLogo(newImageUrl) {
      await onChangeBrandingSettings(newImageUrl, "url");
      setIsUploadingLogo(false);
    };
    $[0] = onChangeBrandingSettings;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onUploadWorkspaceLogo = t0;
  let t1;
  if ($[2] !== onChangeBrandingSettings) {
    t1 = async function removeWorkspaceLogo() {
      await onChangeBrandingSettings("", "url");
    };
    $[2] = onChangeBrandingSettings;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const removeWorkspaceLogo = t1;
  let t2;
  if ($[4] !== onUploadWorkspaceLogo) {
    t2 = uploadedResponse => {
      if (isSingleFileUploadResponse(uploadedResponse)) {
        onUploadWorkspaceLogo(uploadedResponse);
      }
    };
    $[4] = onUploadWorkspaceLogo;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== companyId) {
    t3 = {
      companyId,
      uploadElementType: UploadElementType.default
    };
    $[6] = companyId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== brandingSettings.logo.url || $[9] !== isUploadingLogo || $[10] !== removeWorkspaceLogo || $[11] !== t2 || $[12] !== t3) {
    t4 = <SphereDropzone existingImageUrl={brandingSettings.logo.url} isLoading={isUploadingLogo} setIsLoading={setIsUploadingLogo} onUploadComplete={t2} onDeleteButtonClick={removeWorkspaceLogo} deleteIconTooltipText="Remove workspace logo" context={t3} />;
    $[8] = brandingSettings.logo.url;
    $[9] = isUploadingLogo;
    $[10] = removeWorkspaceLogo;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}